import axios from 'axios';
import get from 'lodash/get';
// import 'whatwg-fetch';

const handleUrl = (url) => {
  return `${get(process.env, 'REACT_APP_BACKEND_URL', '')}${url}`;
  // return `../${url}`;
};

const fetchJson = (url) => {
  const xhttp = new XMLHttpRequest(); // eslint-disable-line
  return new Promise((resolve, reject) => {
    xhttp.onreadystatechange = function () {
      // eslint-disable-line
      if (this.readyState === 4 && this.status === 200) {
        try {
          const data = xhttp.response;
          resolve(JSON.parse(data));
        } catch (error) {
          reject(error);
        }
      }
    };
    xhttp.open('GET', url, true);
    xhttp.send();
  });
};

const getParams = (param = {}) => {
  const res = {
    method: param.method ? param.method : 'GET',
    headers: { 'Content-Type': 'application/json', ...param.headers },
    mode: 'cors', // no-cors, cors, *same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin' // include, *same-origin, omit
  };

  if (res.method === 'POST') { res.body = JSON.stringify(param.body ? param.body : {}); }
  return res;
};

const fetchAPI = (url, param) => {
  return new Promise((resolve, reject) => {
    fetch(handleUrl(url), getParams(param))
      .then(res => res.json())
      .then((data) => {
        try {
          resolve(data);
        } catch (error) {
          reject(error);
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};

const fetchAPIWithOutBaseUrl = (url, param) => {
  return new Promise((resolve, reject) => {
    axios(url, getParams(param))
      .then((data) => {
        try {
          // console.log('then', data);
          resolve(data.data);
        } catch (error) {
          // console.log('catch then', error);
          reject(error);
        }
      })
      .catch((e) => {
        // console.log('catch', e);
        reject(e);
      });
  });
};

const fetchAPIXWWWFrom = (url, param) => {
  return new Promise((resolve, reject) => {
    const urlParam = Object.keys(param.body)
      .map((k) => {
        return `${encodeURIComponent(k)}=${encodeURIComponent(param.body[k])}`;
      })
      .join('&');

    fetch(handleUrl(url), {
      ...getParams(param),
      body: urlParam
    })
      .then(res => res.json())
      .then((data) => {
        try {
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
  });
};

export { fetchJson, fetchAPI, fetchAPIXWWWFrom, fetchAPIWithOutBaseUrl };



// WEBPACK FOOTER //
// ./src/services/api.js